
export const todo = (() => {
    const todolist = document.getElementById("todo-list");
    if (!todolist) return;

    const blockId = todolist.getAttribute('data-blockid')
    const todoCheckboxes = document.querySelectorAll(".todo-checkbox");

    Array.from(todoCheckboxes).forEach((cb) => addEL(cb));

    function addEL(cb) {

        cb.addEventListener("change", function () {
           
            let that = this;
            let state = that.checked;
            that.setAttribute("disabled", "disabled");
            
            const itemId = that.value;
            let data = new FormData();

            data.append("blockId", blockId);
            data.append("ChecklistItem", itemId);

       
            fetch("/checklist/ToggleChecklistItem/?", {
                method: "POST",
                body: data
            })
                .then((result) => {

                    that.removeAttribute("disabled");

                    if (result.status != 200) {
                        alert("Uppgiften gick inte att spara, var god försök igen.\n " + error)
                        that.checked = !state;
                        throw new Error("Bad Server Response");
                    }
                    return result.text();
                })
                .then((response) => {

                    let ResultAsJson = JSON.parse(response);
                    that.removeAttribute("disabled");

                    if (ResultAsJson.success) {
                        todolist.closest(".todo").classList.add("todo-loading");
                        setTimeout(function () {
                            todolist.closest(".todo").classList.remove("todo-loading");
                        }, 2000);
                    }

                })
                .catch((error) => {
                    alert("Uppgiften gick inte att spara, var god försök igen.\n "+error)
                    that.removeAttribute("disabled");
                    that.checked = !state;
                    throw new Error("Bad Server Response");
                });

        });
    }
})();
